module.exports = __webpack_public_path__ + "static/media/horus.4b4eebfe.svg";